import React from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "lang";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { GetNavigationConfig } from "configs/NavigationConfig";
import { useUserData } from "components/UserDataContext/UserDataContext";

// Shown for an address under /app that no screen of this user matches: a screen without the
// right to open it, or one that does not exist.
const NoAccess = () => {
  useTranslation(undefined, { useSuspense: false });
  const { factoryRoles, users } = useUserData();
  const nav = factoryRoles?.length ? GetNavigationConfig(factoryRoles, users?.[0]?.email) : [];
  let home = AUTHENTICATED_ENTRY;
  if (nav.some((x) => x.path === "/app/Home")) home = "/app/Home";
  else if (nav.some((x) => x.path === "/app/Dashboard")) home = "/app/Dashboard";
  return (
    <Result
      status="403"
      title={i18n.t("NoAccessTitle")}
      subTitle={i18n.t("NoAccessText")}
      extra={
        <Link to={home}>
          <Button type="primary">{i18n.t("BackToHome")}</Button>
        </Link>
      }
    />
  );
};

export default NoAccess;
